document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    });
  }

  var sortSelect = document.querySelector('[data-auto-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () { sortSelect.form.submit(); });
  }
  document.querySelectorAll('[data-filter-details]').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      document.querySelectorAll('[data-filter-details]').forEach(function (other) {
        if (other !== details) other.open = false;
      });
    });
  });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-filter-details][open]').forEach(function (details) {
      if (!details.contains(event.target)) details.open = false;
    });
  });

  // Close the compact collection filter panel on outside click or Escape.
  var collectionFilterDrawer = document.querySelector('[data-collection-filter-drawer]');
  if (collectionFilterDrawer) {
    var filterClose = collectionFilterDrawer.querySelector('[data-close-collection-filters]');
    if (filterClose) filterClose.addEventListener('click', function () { collectionFilterDrawer.open = false; });
    document.addEventListener('click', function (event) {
      if (collectionFilterDrawer.open && !collectionFilterDrawer.contains(event.target)) collectionFilterDrawer.open = false;
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && collectionFilterDrawer.open) {
        collectionFilterDrawer.open = false;
        var trigger = collectionFilterDrawer.querySelector('summary');
        if (trigger) trigger.focus();
      }
    });
  }

  // v20: Mobile Navigation hat Vorrang vor Kollektionsfiltern.
  // Ein geöffnetes Filterpanel wird geschlossen, sobald das Menü geöffnet wird.
  var ar20MenuButton = document.querySelector('[data-menu-toggle]');
  var ar20FilterDrawer = document.querySelector('[data-collection-filter-drawer]');
  if (ar20MenuButton && ar20FilterDrawer) {
    ar20MenuButton.addEventListener('click', function () {
      if (document.querySelector('[data-mobile-nav].is-open')) ar20FilterDrawer.open = false;
    });
  }

  var cartForm = document.getElementById('ArielleCartForm');
  if (cartForm) {
    cartForm.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var control = button.closest('.ar-quantity-control');
        var input = control && control.querySelector('[data-cart-quantity]');
        if (!input) return;
        var next = (parseInt(input.value, 10) || 0) + (button.hasAttribute('data-qty-plus') ? 1 : -1);
        input.value = Math.max(0, next);
        var updateButton = document.getElementById('ArielleCartUpdate');
        if (updateButton) updateButton.click();
      });
    });
  }

  var modal = document.querySelector('[data-newsletter-modal]');
  if (modal) {
    var key = 'arielleWelcomeClosed';
    function closeModal() {
      modal.hidden = true;
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
    }
    modal.querySelectorAll('[data-newsletter-close]').forEach(function (button) {
      button.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
    var success = modal.querySelector('.form-success');
    if (success) {
      modal.hidden = false;
    } else {
      var closed = false;
      try { closed = sessionStorage.getItem(key) === '1'; } catch (e) {}
      if (!closed) {
        window.setTimeout(function () {
          if (!document.querySelector('.shopify-challenge__container')) modal.hidden = false;
        }, 7000);
      }
    }
  }
});
